import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { APP_CONFIG } from '../../environment';
import { NavController, NavParams } from 'ionic-angular';
import { IFormControl } from '../../providers/formbuilder/formcontrol.interface';
import { FormControlProvider } from '../../providers/formbuilder/formcontrol';
import { FormControlMapper } from '../../providers/formbuilder/formcontrol-mapper';
import { InputType } from '../../model/types/input-type';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { COUNTRY_SETTINGS, COUNTRY_SETTINGS_ENABLE_VALUE } from '../../providers/myria/app-variables';
import { CustomerProvider } from '../../providers/customer/customer';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { LoadingProvider } from '../../providers/loading/loading';
import { LoqateProvider } from '../../providers/loqate/loqate-provider';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { RmtSnackbarComponent } from '../../components/rmt-snackbar/rmt-snackbar';
import { TranslateService } from '@ngx-translate/core';
const ADDRESS_STEP = 1;


/**
 * Component for updating customer address in settings
 * Emits success/failure status to parent component
 *
 * @example
 * <rmt-address-update 
 *   (addressUpdateEmitter)="handleUpdate($event)">
 * </rmt-address-update>
 */
@Component({
  selector: 'rmt-address-update',
  templateUrl: 'rmt-address-update.html'
})
export class RmtAddressUpdateComponent {

  @ViewChild('form') form;
  displayForm: boolean = true;
  fields: IFormControl[];
  formGroup: FormGroup = new FormGroup({});
  loqateEnable: boolean = false;
  customerFields: any;
  customer = null;
  @Output() addressUpdateEmitter = new EventEmitter<boolean>();

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private readonly formProvider: FormControlProvider,
    private readonly utils: UtilsProvider,
    private readonly translate: TranslateService,
    private readonly customerProvider: CustomerProvider,
    private readonly loadingProvider: LoadingProvider,
    private readonly loqateProvider: LoqateProvider,
  ) {}

  ngOnInit() {
    this.init()
  }

  ngOnDestroy() {
  this.addressUpdateEmitter.complete()
}

  async init() {
    const stepsFields = await this.formProvider.getFieldsDynamicRegistration()
    await this.isLoqateEnabled()
    this.customer = await this.customerProvider.getCustomer(); //  // TODO OBSOLETE. Use '/Profile' instead.
    const step = stepsFields[ADDRESS_STEP]
    this.fields = FormControlMapper.mapCategoryToFields(step)
    this.fields.forEach(field => {
      if (field.id === '4501' && this.loqateEnable) {
        field.type = InputType.Loqate
      }
      field.disabled = false;
    })
    if (this.customer && this.customer.address) {
      this.customerFields = {
        '4601': this.customer.address.city || '',
        '4801': this.customer.address.postCode || '',
        '4701': this.customer.address.stateProvince || '',
        '4501': this.customer.address.street || '',
        '46403': this.customer.address.unitNumber || '',
      }
    }
    this.loqateProvider.setIsAddressPage(true);
    this.loqateProvider.setInitialAddressState(this.customerFields);
  }

  async isLoqateEnabled() {
    try {
      const loqateSetting = await this.utils.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.LOQATE_ADDRESS_ENABLE)
      this.loqateEnable = loqateSetting == COUNTRY_SETTINGS_ENABLE_VALUE
    } catch (ex) { }
  }

  async submitForm() {
    if (!this.form || !this.form.form.valid) return

    this.loadingProvider.show()

    const form = this.form.form.getRawValue()

    let returnData = {
      country: APP_CONFIG.region.defaultCountryFrom,
      stateProvince: form['4701'] || '',
      street: form['4501'] || '',
      postCode: form['4801'] || '',
      city: form['4601'] || '',
      unitNumber: form['46403'] || '',
    }

    try {
      if (this.customer && this.customer.address) {
        this.customer.address.city = returnData.city
        this.customer.address.country = returnData.country
        this.customer.address.postCode = returnData.postCode
        this.customer.address.stateProvince = returnData.stateProvince
        this.customer.address.street = returnData.street
        this.customer.address.unitNumber = returnData.unitNumber
      }

      this.customer.isAddressSourceLoqate = await this.loqateProvider.determineAddressSourceFlag(this.form.form, true);

      await this.customerProvider.updateCustomer(this.customer)
      LoggerProvider.info(this, 'Customer address updated successfully', LoggerEvent.SettingsPage)
      this.loadingProvider.hide()
      RmtSnackbarComponent.present(this.translate.instant('global.genericSuccessText'));
      this.addressUpdateEmitter.emit(true)
    } catch (err) {
      this.loadingProvider.hide()
      LoggerProvider.exception(this, err, LoggerEvent.SettingsPage, 'Failed to update customer address')
      RmtPopupComponent.showException(this, err, this.translate.instant('page.settingsPage.profileDetails.personalInfoError'));
      this.addressUpdateEmitter.emit(false)
    }
  }

  accessFields(event) {
    this.fields = event;
    event.forEach(value => {
      if (this.form.form.controls[value.id]) {
        this.form.form.controls[value.id].setValue(value.value);
      }
    });
  }

  getForms() {
    const forms = [this.formGroup, this.formGroup];
    if (this.form)
      forms[1] = this.form.form;
    return forms;
  }

  isDisabled() {
    return !this.displayForm;
  }

  updateForm(event) {
    this.displayForm = event;
  }

  checkFormChange(event) {
    this.loqateProvider.handleFormValueChange(this.form.form);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-address-update/rmt-address-update.ts